export default __webpack_public_path__ + "static/logo-73bd9760cc6d028ec705228b57bea215.svg";